import { useCallback, useContext, useRef, useEffect } from 'react';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { NIGHTS } from 'contexts/CruiseSearchContext/constants';
import Header from 'components/FiltersModal/Header';
import { Constrain } from 'components/FiltersModal/components';
import { gsap } from 'gsap';
import styled from 'styled-components';
import sizes from 'styles/sizes';
import NightsSelector from './NightsSelector';

const NIGHTS_FILTER = 'nights-filter-wrap';

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 240px;

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    margin-bottom: 0;
    ${props =>
      props.custom
        ? `
      min-height: 0;
      `
        : `
      @media (min-width: ${sizes.media.smallMaxWidth}px) {
        margin-bottom: 0;
        min-height: 325px;
      }
      `}
  }
`;

function Nights() {
  const sectionTitleRef = useRef();
  const { resetSearchSelectingFilter, globalization } =
    useContext(CruiseSearchContext);

  const { filtersDictionary } = globalization?.dictionaries || {};
  const { navNights } = filtersDictionary;

  const onReset = useCallback(() => {
    resetSearchSelectingFilter(NIGHTS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    gsap.set(sectionTitleRef.current, {
      opacity: 0,
    });
    gsap.to(sectionTitleRef.current, {
      opacity: 1,
      ease: 'cubic-bezier(0,0,0,0)',
    });
  }, []);

  return (
    <>
      <Header title={navNights} onReset={onReset} />
      <Constrain
        ref={sectionTitleRef}
        id={NIGHTS_FILTER}
        className="no-top-padding"
      >
        <Wrapper custom={true}>
          <NightsSelector />
        </Wrapper>
      </Constrain>
    </>
  );
}

export default Nights;
